module.exports = __webpack_public_path__ + "img/pay.829c69bf.png";